/**
 * User Type Constants
 * 사용자 유형 상수
 *
 * Note: 실제 데이터는 공통코드 시스템에서 관리됩니다.
 * 이 파일의 상수들은 타입 힌팅과 기본값 용도로만 사용됩니다.
 * 실제 옵션 목록은 commonCodeService.getUserTypeOptions()를 사용하세요.
 */

// 타입 정의 및 기본값 (공통코드와 동기화 필요)
export const USER_TYPES = {
  EMPLOYEE: 'employee',
  EXTERNAL_STAFF: 'external_staff',
  CUSTOMER: 'customer',
  OTHER: 'other',
} as const;

export type UserType = typeof USER_TYPES[keyof typeof USER_TYPES];

// Fallback 레이블 (공통코드 조회 실패 시 사용)
export const USER_TYPE_LABELS: Record<UserType, string> = {
  [USER_TYPES.EMPLOYEE]: '직원',
  [USER_TYPES.EXTERNAL_STAFF]: '외부직원',
  [USER_TYPES.CUSTOMER]: '고객',
  [USER_TYPES.OTHER]: '기타',
};

// Fallback 옵션 (공통코드 조회 실패 시 사용)
// CommonCodeOption 형태와 호환되도록 code, value 사용
export const USER_TYPE_OPTIONS = [
  { id: 1, code: USER_TYPES.EMPLOYEE, value: USER_TYPE_LABELS[USER_TYPES.EMPLOYEE], is_default: false },
  { id: 2, code: USER_TYPES.EXTERNAL_STAFF, value: USER_TYPE_LABELS[USER_TYPES.EXTERNAL_STAFF], is_default: false },
  { id: 3, code: USER_TYPES.CUSTOMER, value: USER_TYPE_LABELS[USER_TYPES.CUSTOMER], is_default: false },
  { id: 4, code: USER_TYPES.OTHER, value: USER_TYPE_LABELS[USER_TYPES.OTHER], is_default: false },
];

// 헬퍼 함수
export const isEmployee = (userType: string): boolean => {
  return userType === USER_TYPES.EMPLOYEE || userType === USER_TYPES.EXTERNAL_STAFF;
};

export const isCustomer = (userType: string): boolean => {
  return userType === USER_TYPES.CUSTOMER;
};
